import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { Observable } from 'rxjs';
import { UsuarioDBService } from '../database/usuario-db.service';
import { Capacitor } from '@capacitor/core';
import { Usuario } from '../alcance/models/usuario';
import { Edificacao } from '../models/edificacao';
import { Equipe } from '../models/equipe';
import { Turno } from '../models/turno';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends BaseService {
    override classname: string = 'UsuarioService';
    public override route: string = 'usuario';
    public override database = Capacitor.isNativePlatform() ? new UsuarioDBService() : new UsuarioDBService();

    override put(data: any, path: string | null = null, params: any = null, headers: any = null): Observable<any>{       
        data = Object.assign({}, data.pessoa, data);
		return super.put(data, path, params, headers);
	}

    assinatura(signature: string | null = null, remover: boolean = false): Observable<Usuario>{
        const data = remover ? {remover_assinatura: true} : {signature};
        return this.http.put<Usuario>(this.url + 'user/assinatura', data, {headers: {showLoader: 'false'}});
    }

    edificacoesParaTransferencia(): Observable<Edificacao[]>{
        return this.http.get<Edificacao[]>(this.url + 'user/edificacoes');
    }

    opcoesTurnosEquipes(): Observable<{turnos: Turno[], equipes: Equipe[]}>{
        return this.http.get<{turnos: Turno[], equipes: Equipe[]}>(this.url + 'user/turnos-equipes');
    }

    transferirEdificacao(edificacaoId: number): Observable<any>{
        return this.http.put(this.url + 'user/edificacao', {
            edificacao_id: edificacaoId
        });
    }

    selecionarEdificacoes(edificacoes: number[]): Observable<any>{
        return this.http.put(this.url + 'user/edificacoes', {edificacoes});
    }

    override novo() {
		return {
            pessoa: {
                telefones: []
            },
            permissoes: {}
        } as any;
	}
}
